
      const apiKey = import.meta.env.VITE_GOOGLE_API; // Replace 'YOUR_API_KEY_HERE' with your actual API key

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap`;
      script.defer = true;
      script.async = true;

      document.head.appendChild(script);
    